import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const FilterToolbar = ({ onFilterChange, onSearchChange, searchQuery, filters }) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const categoryOptions = [
    { value: 'all', label: 'ทุกหมวดหมู่' },
    { value: 'ประกาศ', label: 'ประกาศ' },
    { value: 'ข่าวสาร', label: 'ข่าวสาร' },
    { value: 'กิจกรรม', label: 'กิจกรรม' },
    { value: 'บริการ', label: 'บริการ' },
    { value: 'เตือนภัย', label: 'เตือนภัย' },
    { value: 'ด่วน', label: 'ด่วน' }
  ];

  const sortOptions = [
    { value: 'newest', label: 'ใหม่ที่สุด' },
    { value: 'oldest', label: 'เก่าที่สุด' },
    { value: 'priority', label: 'ความสำคัญ' },
    { value: 'views', label: 'ยอดอ่านสูงสุด' }
  ];

  const priorityOptions = [
    { value: 'all', label: 'ทุกระดับ' },
    { value: 'สูง', label: 'สำคัญมาก' },
    { value: 'กลาง', label: 'สำคัญปานกลาง' },
    { value: 'ปกติ', label: 'ปกติ' }
  ];

  const handleFilterChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6 shadow-government">
      {/* Search Bar */}
      <div className="flex flex-col lg:flex-row gap-4 mb-4">
        <div className="flex-1">
          <div className="relative">
            <Input
              type="search"
              placeholder="ค้นหาข่าวสาร..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="pl-10"
            />
            <Icon 
              name="Search" 
              size={18} 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
            />
          </div>
        </div>
        
        {/* Mobile Filter Toggle */}
        <button
          onClick={() => setIsFilterOpen(!isFilterOpen)}
          className="lg:hidden flex items-center justify-center space-x-2 px-4 py-2 bg-muted hover:bg-muted/80 rounded-md transition-government"
        >
          <Icon name="Filter" size={18} />
          <span>ตัวกรอง</span>
          <Icon 
            name={isFilterOpen ? 'ChevronUp' : 'ChevronDown'} 
            size={16} 
          />
        </button>
      </div>
      {/* Filter Controls */}
      <div className={`grid grid-cols-1 md:grid-cols-3 gap-4 ${
        isFilterOpen ? 'block' : 'hidden lg:grid'
      }`}>
        <Select
          label="หมวดหมู่"
          options={categoryOptions}
          value={filters?.category}
          onChange={(value) => handleFilterChange('category', value)}
          className="w-full"
        />

        <Select
          label="เรียงตาม"
          options={sortOptions}
          value={filters?.sortBy}
          onChange={(value) => handleFilterChange('sortBy', value)}
          className="w-full"
        />

        <Select
          label="ความสำคัญ"
          options={priorityOptions}
          value={filters?.priority}
          onChange={(value) => handleFilterChange('priority', value)}
          className="w-full"
        />
      </div>
      {/* Active Filters Display */}
      {(filters?.category !== 'all' || filters?.priority !== 'all' || searchQuery) && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm text-muted-foreground">ตัวกรองที่ใช้:</span>
            
            {searchQuery && (
              <span className="inline-flex items-center space-x-1 bg-accent/10 text-accent-foreground px-2 py-1 rounded-full text-xs">
                <Icon name="Search" size={12} />
                <span>"{searchQuery}"</span>
                <button
                  onClick={() => onSearchChange('')}
                  className="hover:bg-accent/20 rounded-full p-0.5"
                >
                  <Icon name="X" size={10} />
                </button>
              </span>
            )}
            
            {filters?.category !== 'all' && (
              <span className="inline-flex items-center space-x-1 bg-primary/10 text-primary px-2 py-1 rounded-full text-xs">
                <span>{categoryOptions?.find(opt => opt?.value === filters?.category)?.label}</span>
                <button
                  onClick={() => handleFilterChange('category', 'all')}
                  className="hover:bg-primary/20 rounded-full p-0.5"
                >
                  <Icon name="X" size={10} />
                </button>
              </span>
            )}
            
            {filters?.priority !== 'all' && (
              <span className="inline-flex items-center space-x-1 bg-warning/10 text-warning-foreground px-2 py-1 rounded-full text-xs">
                <span>{priorityOptions?.find(opt => opt?.value === filters?.priority)?.label}</span>
                <button
                  onClick={() => handleFilterChange('priority', 'all')}
                  className="hover:bg-warning/20 rounded-full p-0.5"
                >
                  <Icon name="X" size={10} />
                </button>
              </span>
            )}

            <button
              onClick={() => {
                onFilterChange({ category: 'all', sortBy: 'newest', priority: 'all' });
                onSearchChange('');
              }}
              className="text-xs text-muted-foreground hover:text-foreground transition-government"
            >
              ล้างทั้งหมด
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterToolbar;